    /**
     * Global GA4 analytics helper.
     * Handles click and auxclick events on any element with [data-ga-event].
     */

    /**
     * Fire a GA4 event using the element’s data attributes.
     *
     * @param {Element} element - The DOM element with GA data attributes.
     * @param {string} [defaultCategory=''] - Optional fallback category if data attribute is missing.
     */
    function fireEvent(element, defaultCategory = '') {
        if (!element) return;
    
        const eventName = element.getAttribute('data-ga-event');
        if (!eventName) return;
    
        const category = element.getAttribute('data-ga-category') || defaultCategory;
        const title = element.getAttribute('data-title') || '';
    
        gtag('event', eventName, {
            event_category: category,
            item_title: title
        });
    }
  
    // Attach global listeners once DOM is ready
    document.addEventListener('DOMContentLoaded', () => {
        // Left clicks
        document.addEventListener('click', event => {
            const target = event.target.closest('[data-ga-event]');

            if (target) {
                fireEvent(target);
            }
        });

        // Middle clicks (mouse wheel)
        document.addEventListener('auxclick', event => {
            if (event.button === 1) { // 1 = middle mouse button
                const target = event.target.closest('[data-ga-event]');

                if (target) {
                    fireEvent(target);
                }
            }
        });
    });
    